export const paths = {
  signIn: "/signin",
  orgSelect: "/orgSelect",
  onboarding: "/onboarding",
  company: "/company",
  revenue: "/revenue",
  home: "/",
  setup: "/setup",
};
